var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgRainbow = function SvgRainbow(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg8",
    width: "210mm",
    height: "297mm",
    viewBox: "0 0 210 297",
    ref: ref
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radialGradient1035",
    cx: 106.21,
    cy: 142.41,
    r: 94.872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop1029",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop1031",
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radialGradient1120",
    cx: 106.21,
    cy: 142.41,
    r: 94.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop984",
    offset: 0,
    stopColor: "red"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop994",
    offset: 0.348,
    stopColor: "#f38000"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop996",
    offset: 0.618,
    stopColor: "#ff0",
    stopOpacity: 0.958
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop998",
    offset: 0.781,
    stopColor: "#0f0"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop1000",
    offset: 1,
    stopColor: "#0080ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g842",
    fill: "url(#radialGradient1120)",
    transform: "translate(-1.211 6.092)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g901",
    fill: "url(#radialGradient1120)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g887",
    fill: "url(#radialGradient1120)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g918",
    fill: "url(#radialGradient1120)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g906",
    fill: "url(#radialGradient1120)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g925",
    fill: "url(#radialGradient1120)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g921",
    fill: "url(#radialGradient1120)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g935",
    fill: "url(#radialGradient1120)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "path815",
    cx: 106.21,
    cy: 142.41,
    r: 94.872,
    fill: "url(#radialGradient1120)",
    stroke: "url(#radialGradient1035)",
    strokeWidth: 0.215
  }))))))))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRainbow);
export default ForwardRef;